<div class="overflow-hidden m-a w-fit carousel-indicators-wrapper">
  <div class="carousel-indicators" ngClass="{{ variant }}" #carouselIndicators>
    @for (item of items; track item; let idx = $index) {
      <div class="carousel-dot" [ngClass]="{ 'carousel-dot-active': idx === currentPage }"></div>
    }
  </div>
</div>
